import { isEmptyString }                    from '@cs/components/util';
import { LoggerUtil }                       from '@cs/core';
import { getPropertyOf, isNullOrUndefined } from '@cs/core/utils';
import { Alert }                            from './alert';
import { DashboardPanel }                   from './dashboard-panel';

/**
	* Grid row can be a plain number array or an object with options.
	* Plain: [12] or [6, 6]
	* Object: { cols: [12], sticky: true }
	*/
export interface DashboardGridRowConfig {
	cols: number[];
	sticky?: boolean;
}

export type DashboardGridRowDefinition = number[] | DashboardGridRowConfig;

export class DashboardBehaviour {

	/**
		* Indicate how the refresh behaviour for after notify change to the server
		*/
	refreshAfterChange: 'self' | 'all' | 'none';

	constructor(init: DashboardBehaviour) {

		this.refreshAfterChange = getPropertyOf(init, 'refreshAfterChange', 'all');
	}
}

/**
	* Data that renders the Dashboard grid
	*/
export class DashboardGridData {
	/**
		* Display label for UI
		*/
	label?: string;
	/**
		* Unique name for programming purposes
		*/
	name: string;
	/**
		* Description of the the Dashboard, could be useful for display purposes
		*/
	description?: string;
	/**
		* Shows alerts in the UI
		*/
	alerts?: Alert[]                   = [];
	/**
		* List of dashboard panels
		*/
	panels: DashboardPanel<any, any>[] = [];
	/**
		* Set the layout for the grid/ implemented by the bootstrap grid with a multi dimensional array
		*  [8,4  ], | xxxxxxxxx|xxxx (gridslot: 1 and 2)
		*  [4,4,4], | xxxx|xxxx|xxxx (gridslot: 3, 4 and 5)
		*  [6,6  ]  | xxxxxxx|xxxxxx (gridslot: 6 and 7)
		*/
	grid: DashboardGridRowDefinition[] = [[]];

	latestRefresh: Date;
	behaviour: DashboardBehaviour;

	constructor(init: DashboardGridData) {

		this.label       = init.label;
		this.name        = init.name;
		this.description = init.description;
		this.alerts      = init.alerts
																					? init.alerts.map(a => new Alert(a))
																					: [];

		// @ts-ignore
		this.latestRefresh = isNullOrUndefined(init.latestRefresh) || isEmptyString(init.latestRefresh)
																							? null
																							: new Date(init.latestRefresh);

		if (!init.panels)
			LoggerUtil.warn('No panels specified for the dashboard');
		this.panels = init.panels
																? init.panels.map(a => new DashboardPanel<any, any>(a))
																: [];

		if (!init.grid)
			LoggerUtil.warn('No grid specified for the dashboard');

		this.grid = init.grid
														? init.grid
														: [[]];

		this.behaviour = init.behaviour || {refreshAfterChange: 'all'};

	}
}
